{
  "version": 1,
  "asset_id": "215aaa9c-112e-4c05-9eb1-11d9e9ab2829",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/215aaa9c-112e-4c05-9eb1-11d9e9ab2829/rudolph-new.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/215aaa9c-112e-4c05-9eb1-11d9e9ab2829/rudolph-new.png",
  "original_filename": "rudolph-new.png",
  "size": 659047,
  "content_type": "image/png",
  "created_at": "2026-06-29T03:29:56Z"
}
